import dayjs from "dayjs";
import isBetween from 'dayjs/plugin/isBetween';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import { Operators } from "../../../../fetch-xml/filter";
import { ICondition } from "./ICondition";

dayjs.extend(isBetween);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);

export class DateCondition implements ICondition {
    public isValid(value: string | null, cond: ComponentFramework.PropertyHelper.DataSetApi.ConditionExpression): boolean {
        const inputDate = dayjs(value).startOf('day');
        const condDate = dayjs(cond.value.toString());
        const currentDate = dayjs().startOf('day');
        //@ts-ignore - conditionValue does arrive as a number
        const conditionValue = cond.value as number;
        if (!this._checkValue(value, cond.conditionOperator)) {
            return false;
        }
        switch (cond.conditionOperator) {
            case Operators.On.Value: {
                return inputDate.isSame(condDate);
            }
            case Operators.OnOrAfter.Value: {
                return inputDate.isSameOrAfter(condDate);
            }
            case Operators.OnOrBefore.Value: {
                return inputDate.isSameOrBefore(condDate);
            }
            case Operators.Today.Value: {
                return inputDate.isSame(currentDate);
            }
            case Operators.Yesterday.Value: {
                const oneDayAgo = dayjs().subtract(1, 'day').startOf('day');
                return inputDate.isSame(oneDayAgo);
            }
            case Operators.Tomorrow.Value: {
                const oneDayAfter = dayjs().add(1, 'day').startOf('day');
                return inputDate.isSame(oneDayAfter);
            }
            case Operators.ThisWeek.Value: {
                const startOfWeek = dayjs().startOf('week');
                const endOfWeek = dayjs().endOf('week');
                //'[]'  is used to include both 'startOfWeek' and 'endOfWeek' in the check, meaning both parameters must be passed.
                return inputDate.isBetween(startOfWeek, endOfWeek, 'day', '[]');
            }
            case Operators.ThisMonth.Value: {
                return inputDate.isSame(currentDate, 'month');
            }
            case Operators.ThisYear.Value: {
                return inputDate.isSame(currentDate, 'year');
            }
            case Operators.Next7Days.Value: {
                const sevenDaysFromNow = dayjs().add(7, 'day').startOf('day');
                //'(]' is used to exclude 'currentDate' and to include 'sevenDaysFromNow'  in the check
                return inputDate.isBetween(currentDate, sevenDaysFromNow, null, '(]');
            }
            case Operators.NextXDays.Value: {
                const xDaysFromNow = dayjs().add(conditionValue, 'day').startOf('day');
                //'(]' is used to exclude 'currentDate' and to include 'xDaysFromNow'  in the check
                return inputDate.isBetween(currentDate, xDaysFromNow, null, '(]');
            }
            case Operators.NextXMonths.Value: {
                const endDate = currentDate.add(conditionValue, 'month');
                //'(]' is used to exclude 'currentDate' and to include 'endDate'  in the check
                return inputDate.isBetween(currentDate, endDate, null, '(]');
            }
            case Operators.LastWeek.Value: {
                const startOfCurrentWeek = currentDate.startOf('week');
                const startOfLastWeek = startOfCurrentWeek.subtract(1, 'week');
                const endOfLastWeek = startOfLastWeek.endOf('week');
                //'[]'  is used to include both 'startOfLastWeek' and 'endOfLastWeek' in the check, meaning both parameters must be passed.
                return inputDate.isBetween(startOfLastWeek, endOfLastWeek, 'day', '[]');
            }
            case Operators.Last7Days.Value: {
                const sevenDaysBeforeNow = dayjs().subtract(7, 'day').startOf('day');
                //'[]'  is used to include both 'sevenDaysBeforeNow' and 'currentDate' in the check, meaning both parameters must be passed.
                return inputDate.isBetween(sevenDaysBeforeNow, currentDate, null, '[]');
            }
            case Operators.LastMonth.Value: {
                const startOfLastMonth = currentDate.subtract(1, 'month').startOf('month');
                const endOfLastMonth = currentDate.subtract(1, 'month').endOf('month');
                //'[]'  is used to include both 'startOfLastMonth' and 'endOfLastMonth' in the check, meaning both parameters must be passed.
                return inputDate.isBetween(startOfLastMonth, endOfLastMonth, null, '[]');
            }
            case Operators.LastYear.Value: {
                return inputDate.year() === currentDate.year() - 1;
            }
            case Operators.LastXDays.Value: {
                const xDaysBeforeNow = dayjs().subtract(conditionValue, 'day').startOf('day');
                //'[]'  is used to include both 'xDaysBeforeNow' and 'currentDate' in the check, meaning both parameters must be passed.
                return inputDate.isBetween(xDaysBeforeNow, currentDate, null, '[]');
            }
            case Operators.LastXMonths.Value: {
                const endDate = currentDate.subtract(conditionValue, 'month');
                //'[]'  is used to include both 'currentDate' and 'endDate' in the check, meaning both parameters must be passed.
                return inputDate.isBetween(currentDate, endDate, null, '[]');
            }
            case Operators.DoesNotContainData.Value: {
                return value === null;
            }
            case Operators.ContainsData.Value: {
                return value !== null;
            }
            default: {
            }
        }
        return true;
    }

    private _checkValue(value: string | null, conditionOperator: Operators): boolean {
        if (conditionOperator === Operators.DoesNotContainData.Value || value !== null) {
            return true;
        } else {
            return false;
        }
    }
}